var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightningFilled = function SvgLightningFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 84,
    viewBox: "0 0 52 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.963 83.4997C13.184 83.4937 12.4311 83.2907 11.7691 82.9137C11.7681 82.9137 11.7681 82.9127 11.767 82.9127C9.95905 81.8807 9.10105 79.6917 9.72705 77.7077L18.2871 51.1707L3.91805 46.5387C3.33505 46.3537 2.80205 46.0507 2.33805 45.6427C0.49905 44.0247 0.31905 41.2107 1.93705 39.3717L34.68 2.02066C35.841 0.68966 37.6851 0.17366 39.3721 0.70866C41.7071 1.45266 43.0021 3.95666 42.2601 6.29166L33.6991 32.8217L48.0861 37.4537C49.5191 37.9187 50.607 39.0627 51 40.5127C51.413 41.9487 51.056 43.5017 50.034 44.6367L17.3081 81.9717C16.4811 82.9367 15.257 83.4997 13.963 83.4997Z",
    fill: "white"
  })));
};
export default SvgLightningFilled;